<template>
  <div :class="{ blueBtn: load }">
    <slot v-if="!load"></slot>
    <div v-else class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    load: {
      type: Boolean,
      default: false
    }
  }
};
</script>
